import React from 'react';
import MainLayout from '../components/Layout/MainLayout';
import NewScan from '../components/Scan/NewScan';

const ScanPage = () => (
  <MainLayout><NewScan /></MainLayout>
);

export default ScanPage;